import { render } from "./IconChevronLeftThin.vue?vue&type=template&id=54b9b83c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronLeftThin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54b9b83c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54b9b83c', __exports__)) {
    api.reload('54b9b83c', __exports__)
  }
  
  module.hot.accept("./IconChevronLeftThin.vue?vue&type=template&id=54b9b83c", () => {
    api.rerender('54b9b83c', render)
  })

}


export default __exports__